module.exports = __webpack_public_path__ + "static/img/6094_phase_function_Paper_Points.f34abcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6094_phase_function_Paper_Points.png
// module id = vGKk
// module chunks = 0